/**
 * Enum lists all available in MyDelta time formats.
 *
 * @author michaelp
 */
export enum TimeFormat {
  AmPm = "12-Hour",
  Military = "24-Hour"
}

export type TimeFormatType = {
  value: string;
  label: string;
};

export const timeFormatList: TimeFormatType[] = [
  { label: "12-Hour", value: TimeFormat.AmPm },
  { label: "24-Hour", value: TimeFormat.Military }
]

export function TimeFormatLookup(format: string): TimeFormatType {
  var res = timeFormatList[0];

  timeFormatList.forEach(function (tf) {
    if (tf.value === format) {
      res = tf;
    }
  });

  return res;
}
  